import React from "react";
import FaqHeroSection from "../components/FaqSection/FaqHeroSection";

const Faq = () => {
  return (
    <div>
      <FaqHeroSection />
    </div>
  );
};

export default Faq;
